import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import AddCircleIcon from '@mui/icons-material/AddCircle'
import Grid from '@mui/material/Grid'
import { format } from 'date-fns'

import { useGET_studentsProfileSelectQuery } from 'redux/api/studentsApi'
import { useGET_usersSelectQuery } from 'redux/api/usersApi'
import { useGET_meetingCategoriesQuery } from 'redux/api/meetingsApi'
import { AppDispatch } from 'redux/store'
import {
  setCreator,
  setStartDateFrom,
  setStartDateTo,
  setStatus,
  setStudent,
  setCategory,
  trackActiveFilters,
} from 'redux/ui/meetingsUI'

import DataRangePicker from 'components/atoms/fields/DataRangePicker'
import DatePickerField from 'components/atoms/fields/DatePickerField'
import SelectField from 'components/atoms/fields/SelectField'

import { meetingsStatusSelectData } from 'utils/helpers'
import formModel from 'utils/tableFilterModels/meetingsTableFilterModel'

const ExtraFiltersMeetings = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { t } = useTranslation()

  const { creator, start_date_from, start_date_to, status, student, category } = formModel()

  return (
    <>
      <Grid item xs={12} md={3}>
        <SelectField
          fieldProps={{ ...category }}
          apiCall={useGET_meetingCategoriesQuery}
          onChange={(value: { id: any }) => {
            dispatch(setCategory(value?.id ?? ''))
            dispatch(trackActiveFilters())
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <SelectField
          renderChildren={false}
          fieldProps={{ ...status }}
          apiCall={meetingsStatusSelectData}
          onChange={(value: { id: any }) => {
            dispatch(setStatus(value?.id ?? ''))
            dispatch(trackActiveFilters())
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <SelectField
          fieldProps={{ ...creator }}
          apiCall={useGET_usersSelectQuery}
          onChange={(value: { id: any }) => {
            dispatch(setCreator(value?.id ?? ''))
            dispatch(trackActiveFilters())
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <SelectField
          fieldProps={{ ...student }}
          apiCall={useGET_studentsProfileSelectQuery}
          onChange={(value: { id: any }) => {
            dispatch(setStudent(value?.id ?? ''))
            dispatch(trackActiveFilters())
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <DataRangePicker
          label={t('common.start-date')}
          icon={<AddCircleIcon />}
          fromPicker={
            <DatePickerField
              sx={{ height: 45 }}
              fieldProps={{ ...start_date_from }}
              onChange={(value: Date) => {
                dispatch(setStartDateFrom(value ? format(value, 'yyyy-MM-dd') : ''))
                dispatch(trackActiveFilters())
              }}
            />
          }
          toPicker={
            <DatePickerField
              sx={{ height: 45 }}
              fieldProps={{ ...start_date_to }}
              onChange={(value: Date) => {
                dispatch(setStartDateTo(value ? format(value, 'yyyy-MM-dd') : ''))
                dispatch(trackActiveFilters())
              }}
            />
          }
        />
      </Grid>
    </>
  )
}
export default ExtraFiltersMeetings
